/* Swym Wishlist Plus - theme binding for .wishlist-toggle hearts (product cards).
   Requires the Swym app embed to be enabled (that loads SwymCallbacks / _swat).
   If Swym is not loaded, the callback simply never fires - no errors. */
(function () {
  if (window.__swymWishlistInit) return;
  window.__swymWishlistInit = true;

  window.SwymCallbacks = window.SwymCallbacks || [];

  // Diagnostic: if the Swym app embed is disabled the callback below never fires -
  // surface that instead of failing silently.
  setTimeout(function () {
    if (!window._swat && window.console) {
      console.warn('Swym Wishlist: _swat not found - enable the "Swym Wishlist Plus" app embed in Theme editor > App embeds.');
    }
  }, 4000);

  window.SwymCallbacks.push(function (swat) {
    var wishlisted = Object.create(null);
    var lid = null;

    // First-time visitors have no list yet (fetchLists returns []) - create the
    // default one on demand, otherwise every heart click is a silent no-op.
    function ensureList(cb) {
      if (lid) return cb(lid);
      swat.fetchLists({
        callbackFn: function (lists) {
          if (lists && lists.length) { lid = lists[0].lid; return cb(lid); }
          swat.createList(
            { lname: 'My Wishlist' },
            function (list) { lid = (list && list.lid) || null; cb(lid); },
            function (err) { if (window.console) console.warn('Swym createList failed', err); cb(null); }
          );
        },
        errorFn: function (err) { if (window.console) console.warn('Swym fetchLists failed', err); cb(null); }
      });
    }
    ensureList(function () {});

    function key(empi, epi) { return String(empi) + ':' + String(epi); }

    function updateCount(n) {
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }

    function markButtons() {
      document.querySelectorAll('.wishlist-toggle').forEach(function (btn) {
        var on = !!wishlisted[key(btn.getAttribute('data-swym-empi'), btn.getAttribute('data-swym-epi'))];
        btn.classList.toggle('is-wishlisted', on); // product-card
        btn.classList.toggle('is-active', on);     // fresh-card (.ct__wish)
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function refresh() {
      swat.fetch(function (items) {
        wishlisted = Object.create(null);
        (items || []).forEach(function (it) { wishlisted[key(it.empi, it.epi)] = true; });
        updateCount((items || []).length);
        markButtons();
      }, function (err) { if (window.console) console.warn('Swym fetch failed', err); });
    }

    function productFrom(btn) {
      return {
        empi: parseInt(btn.getAttribute('data-swym-empi'), 10),
        epi: parseInt(btn.getAttribute('data-swym-epi'), 10),
        du: btn.getAttribute('data-swym-du'),
        iu: btn.getAttribute('data-swym-iu'),
        dt: btn.getAttribute('data-swym-dt'),
        pr: parseFloat(btn.getAttribute('data-swym-pr')) || 0
      };
    }

    // Delegated click so it works for lazily-rendered / filtered cards too
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.wishlist-toggle');
      if (!btn) return;
      e.preventDefault();
      var product = productFrom(btn);
      var k = key(product.empi, product.epi);
      btn.classList.add('is-loading');
      ensureList(function (listId) {
        if (!listId) { btn.classList.remove('is-loading'); return; }
        var done = function () { btn.classList.remove('is-loading'); refresh(); };
        if (wishlisted[k]) {
          swat.deleteFromList(listId, product, function () { wishlisted[k] = false; markButtons(); done(); }, done);
        } else {
          swat.addToList(listId, product, function () { wishlisted[k] = true; markButtons(); done(); }, done);
        }
      });
    });

    refresh();
    // Re-apply state when a section re-renders (collection filters / pagination)
    document.addEventListener('shopify:section:load', markButtons);
    // Theme's AJAX filter/sort re-render (collection.js facet-form) recreates the
    // card buttons - re-mark them so already-wishlisted hearts stay active
    document.addEventListener('collection:reloaded', markButtons);
    // Cards appended with no event (infinite scroll / "load more", predictive search,
    // recommendations): watch the DOM for new hearts, debounced against render churn
    var markTimer = null;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('.wishlist-toggle')) || (n.querySelector && n.querySelector('.wishlist-toggle'))) {
            clearTimeout(markTimer);
            markTimer = setTimeout(markButtons, 100);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
